import { createApi } from '@reduxjs/toolkit/dist/query/react';

import type IBaseRequest from '../types/Base/BaseRequestInterface';
import {
  type IDeviceCreateRequest,
  type IDeviceDeactivateRequest,
  type IDevicesGetResponse,
  type IDevicesResponse,
} from '../types/DevicesTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const DevicesApi = createApi({
  reducerPath: 'DevicesApi',
  tagTypes: ['Devices'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getDevices: build.query<IDevicesGetResponse, IBaseRequest>({
      query: (params) => ({
        url: '/devices/',
        method: 'GET',
        params: { page: params?.page || 1, page_size: params?.page_size || 0 },
      }),
      providesTags: [{ type: 'Devices', id: 'LIST' }],
    }),
    getDevice: build.query<IDevicesResponse, string>({
      query: (id: string) => ({
        url: `/devices/${id}/`,
        method: 'GET',
      }),
      providesTags: [{ type: 'Devices', id: 'LIST' }],
    }),
    getQr: build.query<any, string>({
      query: (deviceId: string) => ({
        url: `/devices/get_token_qr/${deviceId}/`,
        method: 'GET',
        responseHandler: async (response) => {
          const blob = await response.blob();
          return window.URL.createObjectURL(blob);
        },
      }),
      providesTags: [{ type: 'Devices', id: 'LIST' }],
    }),
    createDevice: build.mutation<IDevicesGetResponse, IDeviceCreateRequest>({
      query: (body: IDeviceCreateRequest) => ({
        url: '/devices/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Devices', id: 'LIST' }],
    }),
    deactivateDevice: build.mutation<IDevicesResponse, IDeviceDeactivateRequest>({
      query: (body: IDeviceDeactivateRequest) => ({
        url: `/devices/deactivate/${body.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Devices', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetDevicesQuery,
  useGetDeviceQuery,
  useGetQrQuery,
  useCreateDeviceMutation,
  useDeactivateDeviceMutation,
} = DevicesApi;
